declare var autoCompleteDebug: boolean
declare var autoCompleteUrl: string
declare var directMatchUrl: string

var log = !autoCompleteDebug
    ? function (test: any[]) { }
    : function (test: any[]) {
        if (console) {
            console.log.apply(arguments);
        }
    };
var warn = autoCompleteDebug ? console.warn : function () { };
var jsonIndent = autoCompleteDebug ? 2 : undefined;
//var /* const */ autoCompleteDelay = 350; // ms debounce delay on auto-complete search
// Alberto Oliva 2019-03-04. Loop54 recommended to send a request per typed letter.
const autoCompleteDelay = 100; // ms debounce delay on auto-complete search
const showHideDelay = 500; // ms
const selInputBox = 'globalSearchtext';

var autoCompleteIsShowing = false;

type AutoCompleteSearchRequestModel = {
    UserId: string
    QueryString: string
};

var baseAutoCompleteSearchRequest: AutoCompleteSearchRequestModel =
{
    UserId: "A-User-ID",
    QueryString: ""
}

var lastAutoCompleteResult: any = { Success: false }; // Loop54's JSON doesn't use camelCase.
var lastDirectResult: any = null;

function checkCanSearch() {
    var canSrch = (document.getElementById(selInputBox) as HTMLInputElement).value!.length !== 0;    
    document.getElementById('globalSearchButton')?.setAttribute('disabled', String(!canSrch));
}

function doAutoCompleteSearch() {
    let now = new Date();
    let ms = now.getUTCSeconds() * 1000 + now.getUTCMilliseconds();
    log([
        'Auto Complete Search Starts Here! at ' + ms.toString() + 'ms'
    ]);

    var srchText = (document.getElementById(selInputBox) as HTMLInputElement).value;

    var req = baseAutoCompleteSearchRequest;

    req.QueryString = srchText;
    log(['AutoComplete query being sent', JSON.stringify(req)]);

    function showNewResults() {
        if (showAutoCompleteResults({ autoComplete: lastAutoCompleteResult, direct: lastDirectResult })) {
            showAutoComplete(true);
        } else {
            hideAutoComplete();
        }
    }

    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    fetch(autoCompleteUrl, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(req)
    })
        .then(response => response.json())
        .then(function (data: any) {
            log(['Raw Output From AutoComplete Search', JSON.stringify(data)]);
            lastAutoCompleteResult = data;
            showNewResults();
        });


    fetch(directMatchUrl.replace('--q--', srchText), {
        method: 'GET',
        headers: requestHeaders,
    })
        .then(response => response.json())
        .then(function (data) {
            log(["Have direct results: ", JSON.stringify(data)]);
            lastDirectResult = data;
            showNewResults();
        });
}

// Alberto Oliva 2019-03-04. Loop54 recommended to send a request per typed letter. Need to add a delay on "keydown", as the event will be triggered before the value of the textbox is properly updated, otherwise.
//let autoCompleteSearch = debounce(doAutoCompleteSearch, autoCompleteDelay, { 'maxWait': 1000 });
let autoCompleteSearch = function () { setTimeout(doAutoCompleteSearch, autoCompleteDelay); };

function hideAutoComplete() {
    if (autoCompleteIsShowing) {
        setTimeout(() => {
            let el = document.getElementById('searchAutoCompleteList');
            el!.style!.display = 'none';
            el!.style!.opacity = '0';
            el!.classList.remove('show-results');
            document.getElementById('clearbutton')?.classList.remove('show');
        }, showHideDelay);

        autoCompleteIsShowing = false;
    }
}

function onClickAutoCompleteResult(e: any) {
    e.preventDefault();
    hideAutoComplete();
    log(["AutoComplete Entry Click!"]);
    useAutoCompleteForSearch(e.target.closest('li'));
}

function onSearchKeyDown(e: any) {
    var d = e.key === 'ArrowDown' || e.key === 'Down';
    var u = e.key === 'ArrowUp' || e.key === 'Up';
    var l = e.key === 'ArrowLeft' || e.key === 'Left';
    var r = e.key === 'ArrowRight' || e.key === 'Right';
    if (autoCompleteIsShowing) {
        if (d || u) {
            e.preventDefault();

            let allLinks = document.getElementById('searchAutoCompleteLinks')!.children;

            let current = document.getElementById('searchAutoCompleteLinks')!.getElementsByClassName('selected')[0];

            for (let i = 0; i < allLinks.length; i++) {
                var link = allLinks[i];

                link.classList.remove('selected');
            }

            if (d) {
                let n = current?.nextElementSibling;
                if (n == null) {
                    n = allLinks[0];
                }
                n!.classList.add('selected');
            } else {
                let p = current?.previousElementSibling;
                if (p == null) {
                    p = allLinks[allLinks.length - 1];
                }
                p!.classList.add('selected');
            }
        } else if (e.key === "Escape" || e.key === 'Esc') {
            e.preventDefault();
            hideAutoComplete();
        } else if (!(l || r) && e.key !== "Enter") { // if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Del') // "Del" for IE9/FF36 compat
            autoCompleteSearch();
        }
        return;
    }
    // Andriod Chrome doesn't provide keypress events, and here e.keyCode &
    // e.which are useless. So just fire autocomplete here rather than
    // in the keypress handled.
    if (e.key !== "Enter" && !(d || u || l || r)) {
        autoCompleteSearch();
    }
}

function onSearchKeyPress(e: any) {
    log(['onSearchKeyPress: ' + e.key]);
    if (e.key === "Enter") {
        if (autoCompleteIsShowing) {
            let sel = document.getElementById('searchAutoCompleteLinks')!.getElementsByClassName('selected');
            hideAutoComplete();
            if (sel.length > 0) {
                e.preventDefault();
                useAutoCompleteForSearch(sel[0]);
                return;
            }

            // Not selecting an auto-complete so just search from query
            return;
        }
    }
    autoCompleteSearch();
}

function show(el: HTMLElement, addDelay: boolean = false) {
    el!.classList.add('show-results');
    if (addDelay) {
        setTimeout(() => {
            el!.style!.display = 'block';
            el!.style!.opacity = '1';
            document.getElementById('clearbutton')?.classList.add('show');
        }, showHideDelay);
    } else {
        el!.style!.display = 'block';
        el!.style!.opacity = '1';
        document.getElementById('clearbutton')?.classList.add('show');
    }
}

function hide(el: HTMLElement, addDelay: boolean = false) {
    setTimeout(() => {
        el!.style!.display = 'none';
        el!.style!.opacity = '0';
        el!.classList.remove('show-results');
    }, showHideDelay);
}

function showAutoComplete(haveResults: boolean) {
    let el = document.getElementById('searchAutoCompleteList')!;
    // If not currently showing, only show if results (to avoid bouncing open
    //.to briefly show spinner before closing)
    if (haveResults && !autoCompleteIsShowing) {
        autoCompleteIsShowing = true;
        let el = document.getElementById('searchAutoCompleteList')!;
        show(el, true);
    }
    let spinner = document.getElementById('searchAutoCompleteWait')!;
    let list = document.getElementById('searchAutoCompleteLinks')!;

    if (haveResults) {
        log(['showAutoComplete: have results'])

        hide(spinner);
        show(el);
        show(list);
    } else {
        // No results (yet) show spinner
        log(['showAutoComplete: waiting for results'])
        show(spinner);
        list!.innerHTML = "";
        hide(list);
    }
}

function showAutoCompleteResults(autoCompleteResults: any) {
    var autoCompRes = autoCompleteResults.autoComplete;

    if (!autoCompRes.Success && !autoCompleteResults.direct) {
        warn("No autocomplete results");
        return false;
    }
    var acr = [];
    if (autoCompleteResults.direct && autoCompleteResults.direct.title) {
        var dr = autoCompleteResults.direct;
        log(["Have a direct result "]);
        acr.push({ text: dr.title, direct: dr.url });
    }
    var facets = [], matches = [];

    if (autoCompRes.Success) {
        autoCompRes = autoCompRes.Data;
        matches = autoCompRes.AutoComplete.map(function (d: any) { return ({ text: d.Key, facet: null }); });

        let qry = autoCompRes.QueryString;
        facets = autoCompRes.AutoCompleteFacets
            ? autoCompRes.AutoCompleteFacets.map(function (d: any) { return ({ text: autoCompRes.AutoCompleteFacetingString, facet: d.Key }); })
            : [];
    }
    let results = acr.concat(facets, matches).slice(0, 10);

    if (results.length === 0) { return false; }

    var linksEl = document.getElementById('searchAutoCompleteLinks')!;

    linksEl.innerHTML = "";

    results.map(function (r: any) {
        var div = document.createElement('li');

        div.classList.add('auto-complete-result');

        var a = document.createElement('a');

        a.href = '#';

        a.setAttribute('data-query', r.text);

        if (r.direct) {
            div.classList.add("auto-complete-direct");
            a.setAttribute('data-direct', r.direct);
            a.append('Browse to ' + r.text);
        } else {
            a.setAttribute('data-facet', r.facet || '');
            a.append(r.text);
            if (r.facet) {
                a.append(' in');
                var span = document.createElement('span')

                span.classList.add('complete-in-facet');
                span.textContent = r.facet;

                a.append(span);
            }
        }
        div.append(a);
        linksEl.append(div)
        return div;
    })

    return true;
}

function useAutoCompleteForSearch(ul: any) {
    var anchor = ul!.getElementsByTagName('a')!.item(0);
    var direct = anchor!.getAttribute('data-direct');
    if (direct) {
        document.location = direct;
        return;
    }

    console.log(anchor);

    let text = anchor!.getAttribute('data-query');
    let facet = anchor!.getAttribute('data-facet');
    (document.getElementById(selInputBox) as HTMLInputElement).value = text ?? "";
    (document.getElementById('globalSearchInitialFacet') as HTMLInputElement).value = facet ?? "";

    var searchForm = <HTMLFormElement>document.getElementById('globalSearchForm');
    searchForm.submit();
}

function initialise() {
    log(["AutoComplete init"]);
    var input = document.getElementById(selInputBox)!;
    if (input) {
        input.onkeydown = onSearchKeyDown;
        input.onkeypress = onSearchKeyPress;
        input.onchange = checkCanSearch;

        checkCanSearch();

        document.getElementById('searchAutoCompleteLinks')!.onclick = onClickAutoCompleteResult;

        document.body.onclick = function (e) {
            hideAutoComplete();
        };
        document.getElementById('clearbutton')!.onclick = function (e) {
            (document.getElementById(selInputBox) as HTMLInputElement).value = '';
        };
    }
}

document.addEventListener("DOMContentLoaded", function (event) {
    initialise();
});
